export const UNNAMED_ORGANISATION_LABEL = "Unnamed organisation";

export function getOrganisationDisplayName(organisation = {}) {
  const id = String(organisation?.id || "").trim();
  const name = typeof organisation?.name === "string"
    ? organisation.name.trim()
    : "";
  return name && name.toLowerCase() !== id.toLowerCase()
    ? name
    : UNNAMED_ORGANISATION_LABEL;
}
